/* eslint-disable no-console */

import { register } from "register-service-worker";

import vm from "@/main";

if (process.env.NODE_ENV === "production") {
  try {
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log("App is being served from cache by a service worker.");
      },
      registered() {
        console.log("Service worker has been registered.");
      },
      cached() {
        console.log("Content has been cached for offline use.");
        if (vm) {
          vm.$vs.notify({
            color: "success",
            title: "App Downloaded",
            text:
              "App has been downloaded for offline use. You can now install/add or use this app without an internet connection.",
            time: 30000,
            position: "top",
          });
        }
      },
      updatefound() {
        console.log("New content is downloading.");
        if (vm) {
          vm.$vs.notify({
            color: "warning",
            title: "Downloading App",
            text:
              "Downloaded app for offline use. This should take just a few seconds :)",
            time: 25000,
            position: "top",
          });
        }
      },
      updated() {
        console.log("App updated");
        if (vm) {
          vm.$vs.notify({
            color: "success",
            title: "App Updated",
            text:
              "App successfully updated to the latest version. Restarting in 5 seconds to complete update.",
            time: 25000,
            position: "top",
          });
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      },
      offline() {
        console.log(
          "No internet connection found. App is running in offline mode."
        );
        if (vm) {
          vm.$vs.notify({
            color: "warning",
            title: "Internet Unavailable",
            text:
              "An internet connection has not been detected. This app will run in offline mode. We'll sync the data once connection is restored.",
            time: 20000,
            position: "top",
          });
        }
      },
      error(error) {
        console.error("Error during service worker registration:", error);
        if (vm) {
          vm.$vs.notify({
            color: "danger",
            title: "Error",
            text:
              "An error occurred during startup. Restart app to fix error. Details: " +
              error,
            time: 20000,
            position: "top",
          });
        }
      },
    });
  } catch (e) {
    console.log("Service worker error", e);
  }
}
